// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"29e52ff4","648":"6d8e4c44"}[chunkId] + ".chunk.css";
};